import { checkEqualOrIncludes } from "./checkEqualOrIncludes";
import { ConfigFilter, SelectedFilters } from "../types";

export const getFilterValue = <T extends string | number>({
  selectedFilters,
  configFilters,
  filterName,
  newValue,
}: {
  selectedFilters: SelectedFilters;
  configFilters: ConfigFilter[];
  filterName: string;
  newValue?: T;
}): T[] => {
  const value = selectedFilters?.[filterName]?.value as T[];

  if (value?.length && Array.isArray(value)) {
    const valueClone = [...value];
    const filterIndex = valueClone.indexOf(newValue as T);

    if (filterIndex >= 0) {
      valueClone.splice(filterIndex, 1);
    } else {
      valueClone.push(newValue as T);
    }

    return valueClone;
  }

  const configFilter = configFilters?.find(({ name }) => name === filterName);

  if (!value) {
    if (checkEqualOrIncludes(configFilter?.defaultValue, newValue)) {
      return [];
    }

    if (configFilter?.defaultValue) {
      return [
        newValue,
        ...(Array.isArray(configFilter.defaultValue)
          ? (configFilter.defaultValue as T[])
          : [configFilter.defaultValue as T]),
      ];
    }
  }

  return [newValue];
};
